import { useEffect, useMemo, useState } from "react";
import { useSearchContext } from "domains/search/contexts/SearchProvider";
import { MeilisearchResult } from "domains/search/interfaces/Search";
import _ from "lodash";

export default function useAssetFilterTags(isEnabled = true) {
  const { getAllIndexes, searchWithTokenRenewal } = useSearchContext();
  const [wasEnabled, setWasEnabled] = useState<boolean>(isEnabled);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [tags, setTags] = useState<string[]>([]);
  const [facets, setFacets] = useState<Record<string, number>>({});

  const privateIndex = useMemo(
    () => getAllIndexes("asset").private,
    [getAllIndexes]
  );

  useEffect(() => {
    if (isEnabled && !wasEnabled) {
      setWasEnabled(true);
    }
  }, [isEnabled, wasEnabled]);

  useEffect(() => {
    if (!privateIndex) return;
    if (!searchWithTokenRenewal) return;
    if (!wasEnabled) return;

    const search = async () => {
      try {
        setIsLoading(true);
        setWasEnabled(true);

        const query = {
          indexName: privateIndex,
          params: {
            query: "",
            filters: `tags IS NOT EMPTY`,
            facets: ["tags"],
            hitsPerPage: 0,
          },
        };

        const response = await searchWithTokenRenewal([query]);
        if (!response) return;
        const results: MeilisearchResult[] = response.results;
        setTags((tags) =>
          _.intersection(Object.keys(results[0]?.facets.tags ?? {}), tags)
        );
        setFacets(_.mapValues(results[0]?.facets.tags, () => 0));
      } catch (error) {
        setTags([]);
        setFacets({});
      } finally {
        setIsLoading(false);
      }
    };
    void search();
  }, [privateIndex, searchWithTokenRenewal, setTags, wasEnabled]);

  return {
    tagsQueryArgs: {
      tags,
    },
    fmHeaderFilterTagsProps: {
      value: tags,
      setValue: setTags,
      facets,
      isLoading,
    },
  };
}
